import { takeLatest } from 'redux-saga/effects';
import { CREATE_PARTNER_REQUEST } from '../../redux/modules/resPartner/resPartner-actions';
import createResPartnerWorker from './resPartnerWorkerSaga';

export default function* createResPartnerWatcher() {
    yield takeLatest(CREATE_PARTNER_REQUEST, createResPartnerWorker);
}
